import { OPTIMIZATION_OBJECTIVE, OPTIMIZATION_WAYPOINT_ROLE } from '../servicebus/optimization';
import type { OptimizationRequestPayload } from '../servicebus/optimization';
import { ObjectFactory } from './object.factory';

export class OptimizationRequestPayloadFactory extends ObjectFactory<OptimizationRequestPayload> {
  protected getDefaults(): OptimizationRequestPayload {
    return {
      objective: OPTIMIZATION_OBJECTIVE.TIME,
      waypoints: [
        {
          coordinates: { latitude: 48.8606, longitude: 2.3376 },
          id: 'waypoint-pickup-1',
          link: { linkId: 'task-1', role: OPTIMIZATION_WAYPOINT_ROLE.PICKUP },
          serviceTimeInSeconds: 300,
        },
        {
          coordinates: { latitude: 48.8738, longitude: 2.295 },
          id: 'waypoint-delivery-1',
          link: { linkId: 'task-1', role: OPTIMIZATION_WAYPOINT_ROLE.DELIVERY },
          serviceTimeInSeconds: 300,
        },
        {
          coordinates: { latitude: 48.8529, longitude: 2.3499 },
          id: 'waypoint-standalone',
          serviceTimeInSeconds: 180,
        },
      ],
      vehicles: [{ id: 'vehicle-1', start: { coordinates: { latitude: 48.8566, longitude: 2.3522 } } }],
    };
  }
}

// Pre-instantiated for convenience
export const optimizationRequestPayloadFactory = new OptimizationRequestPayloadFactory();
